/**
 * ConfirmActionDialog — generic overlay dialog for Edit approval,
 * Move confirmation, Remove confirmation, and Reject confirmation.
 *
 * The caller provides the body content via `children` and controls
 * the footer buttons via props.
 *
 * @param {{
 *   isOpen: boolean,
 *   onClose: () => void,
 *   title: string,
 *   children: React.ReactNode,
 *   onConfirm: () => void,
 *   confirmLabel: string,
 *   onReject?: () => void,
 *   rejectLabel?: string,
 *   submitting: boolean,
 * }} props
 */
const ConfirmActionDialog = ({
  isOpen,
  onClose,
  title,
  children,
  onConfirm,
  confirmLabel = 'Approve',
  onReject,
  rejectLabel = 'Reject',
  submitting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="dp-drawer-backdrop" onClick={onClose} aria-hidden="true">
      <div
        className="ehr-dialog"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {/* Header */}
        <div className="ehr-dialog__header">
          <h3 className="ehr-dialog__title">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="dp-drawer__close"
            aria-label="Close dialog"
          >
            <svg className="dp-icon-lg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body — caller-provided content */}
        <div className="ehr-dialog__body">
          {children}
        </div>

        {/* Footer */}
        <div className="ehr-dialog__footer">
          <div className="ehr-dialog__footer-left">
            {onReject ? (
              <button
                type="button"
                onClick={onReject}
                className="dp-btn dp-btn--danger-outline"
                disabled={submitting}
              >
                {rejectLabel}
              </button>
            ) : null}
          </div>
          <div className="ehr-dialog__footer-right">
            <button
              type="button"
              onClick={onClose}
              className="dp-btn dp-btn--secondary"
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={submitting}
              className="dp-btn dp-btn--primary"
            >
              {submitting ? 'Processing...' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionDialog;
